// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import store from './store'
import Loading from 'vue-loading-overlay'  // Loading插件
import 'vue-loading-overlay/dist/vue-loading.css'

// Core JS Files
import '../static/js/core/bootstrap-material-design.min'
// Control Center for Material Dashboard: parallax effects, scripts for the example pages etc
import '../static/js/material-kit?v=2.1.1'


// import 'bootstrap'
import 'datatables.net-bs4'
import 'datatables.net-responsive-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css'

import i18n from '../common/plugins/vue-i18n' // 這邊引入

Vue.config.productionTip = false

// axios.defaults.baseURL = "http://home.kellenkuo.com:8000/";
Vue.use(VueAxios, axios)         // 必須use後才能使用
Vue.use(Vuex)

Vue.component('Loading', Loading)

axios.defaults.withCredentials = true // 重要！axios預設不帶cookies header

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n, // 這邊也引入，跟router,vuex 使用方式是一樣的
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js